/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Required_Toggle_Patterns_DescriptionInputs */



/**
* | output |
* | --- |
* | "Please enable compliance in settings to enable or disable patterns." |
*
* @param {Compliance_Required_Toggle_Patterns_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_required_toggle_patterns_description = /** @type {((inputs?: Compliance_Required_Toggle_Patterns_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Required_Toggle_Patterns_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte aktiviere Compliance in den Einstellungen, um Muster zu aktivieren oder zu deaktivieren.")
	return /** @type {LocalizedString} */ ("Please enable compliance in settings to enable or disable patterns.")
});